import axios from 'axios';
import * as humps from 'humps';
import merge from 'lodash.merge';
import csrfToken from '../utils/csrf-token';
function api(options) { const mergedOptions = merge({ headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CSRF-Token': csrfToken() } }, options); return axios(mergedOptions).then(response => { if (response.data) {
    return Object.assign(humps.camelizeKeys(response.data), { headers: response.headers });
} return null; }); }
export default api;
